import { useState } from "react";
import { useSelector } from "react-redux";
import props from "../../../redux/props";
import Input from "../../UI/Input/Input";
import Form from "../../UI/Form/Form";
import {
  awsLambdaURLPrefix,
  awsSendMailLambdaPrefix,
  MAIL_INTENT,
} from "../../../utility";
import Button from "../../UI/Button/Button";
import styled from "styled-components";
import Textarea from "../../UI/Textarea/Textarea";
import axios from "axios";

type Contact = {
  firstname?: string;
  lastname?: string;
  mail?: string;
  phone?: string;
  subject?: string;
  text?: string;
};

const Wrapper = styled.div`
  width: calc(50% - 15px / 2);
`;

enum Status {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR,
}

const ContactForm: React.FC<{}> = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);
  const [data, setData] = useState<Contact>({});
  const [status, setStatus] = useState<Status>(Status.IDLE);

  const submit = async () => {
    try {
      setStatus(Status.LOADING);
      const result = await axios({
        method: "POST",
        url: awsLambdaURLPrefix + awsSendMailLambdaPrefix,
        data: { ...data, intent: MAIL_INTENT.CONTACT },
      });
      if (result.status) {
        setData({});
        setStatus(Status.SUCCESS);
      } else {
        setStatus(Status.ERROR);
      }
    } catch (error) {
      setStatus(Status.ERROR);
    }
  };

  const set = (key: keyof Contact) => (value: string) =>
    setData({ ...data, [key]: value });

  return (
    <div>
      <Form onSubmit={submit}>
        <div className="flex gap-5 mt-10">
          <div className="flex flex-wrap gap-[15px] w-full">
            <Wrapper>
              <Input
                required
                value={data.firstname}
                placeholder={`${t.generic.firstname}`}
                onChange={set("firstname")}
              />
            </Wrapper>
            <Wrapper>
              <Input
                required
                value={data.lastname}
                placeholder={`${t.generic.lastname}`}
                onChange={set("lastname")}
              />
            </Wrapper>
            <Wrapper>
              <Input
                required
                type="email"
                value={data.mail}
                placeholder={`${t.generic.mail}`}
                onChange={set("mail")}
              />
            </Wrapper>
            <Wrapper>
              <Input
                required
                value={data.phone}
                placeholder={`${t.generic.phone}`}
                onChange={set("phone")}
              />
            </Wrapper>
            <Input
              required
              value={data.subject}
              placeholder={`${t.generic.subject}`}
              onChange={set("subject")}
            />
            <Textarea
              required
              value={data.text}
              placeholder={`${t.generic.text}`}
              onChange={set("text")}
            />
            <div className="text-sm text-blue">{t.contact.section.hint}</div>
            <div className="text-sm text-blue">
              {t.contact.section.privacyHintPrefix}
              <a href={t.contact.section.privacyHintLink} className="underline">
                {t.contact.section.privacyHintLinkLabel}
              </a>
              {t.contact.section.privacyHintSuffix}
            </div>
          </div>
        </div>
        {(status === Status.IDLE || status === Status.ERROR) && (
          <div className="mt-5 w-fit mx-auto">
            <Button
              text={t.contact.section.cta}
              type="submit"
              className="w-full uppercase !px-20"
            />
          </div>
        )}
      </Form>
      {status === Status.SUCCESS && (
        <div className="mt-5 w-fit mx-auto">
          <p className="text-green-500">{t.contact.section.success}</p>
        </div>
      )}
      {status === Status.ERROR && (
        <div className="mt-5 w-fit mx-auto">
          <p className="text-red-500">{t.contact.section.error}</p>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
